/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable import/no-anonymous-default-export */
import  { useEffect, useState } from 'react'

import Slider from "react-slick";
import axios from 'axios';
import { Helmet } from 'react-helmet';
export default function Categories() {
  const [categories,setCategories] = useState([]);
  const [isLoading, setIsloading] = useState(false);
    async function getCategories() {
        setIsloading(true)
        let {data} = await axios.get(`https://ecommerce.routemisr.com/api/v1/categories`);
            setCategories(data.data);
            setIsloading(false)
        }
    useEffect(()=> {
        getCategories();
    }, [])
    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 2,
        };
    return (
        <>
            <Helmet>
                <title>Categories</title>
            </Helmet>
            <Slider {...settings} className='mt-5'>
                        {categories?.map((category) => <div key={category._id }>
                            <img height={200} className='w-100' src={category.image} />
                            <h2 className='h6 pt-2'>{category.name}</h2>
                        </div>)}
                    </Slider>
                    
            <div className="row py-3 my-5">
                {isLoading ? <div className='div-spin'><i className='fas fa-spinner fa-spin fa-3x text-main'></i></div> : <>
                    {categories?.map((category) => (
                    <div key={category._id } className="col-md-2">
                        <div className="product cursor-pointer px-2 py-3">
                        <img height={300}  className='w-100' src={category.image} />
                        <h2 className='h6 pt-2'>{category.name}</h2>
                        </div>
                    </div>
                ))}
                </>}
            </div>
        </>
    )
}
